export enum LOGGING_LEVEL {
  VERBOSE = 'Verbose',
  DEBUG = 'Debug',
  INFORMATION = 'Information',
  WARNING = 'Warning',
  ERROR = 'Error',
  FATAL = 'Fatal',
}

export const LOG_STATE_PICK = [
  'transactionId',
  'frameId',
  'layoutId',
  'quantityPicOfPerSheet',
  'quantitySheet',
  'themeCategoryId',
  'themeId',
  'themeDetailId',
  'elementId',
  'filterId',
];

export const LOG_PROPERTIES = {
  Application: 'fe-booth',
  BoothId: 'NB000001',
  user: 'Liam',
};
